class CathayLoyaltyForm extends HTMLElement {
  constructor() {
    super();
    this.updateTimeout = null;
    this.initialized = false;
    this.cartObserver = null;
  }

  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.setupEventListeners();
    this.setupCartObserver();
    this.checkCartItems();

    document.addEventListener("cart:updated", () => {
      this.checkCartItems();
    });

    this.waitForCart();
  }

  setupCartObserver() {
    this.cartObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          this.checkCartItems();
        }
      });
    });

    this.cartObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["x-data", "x-show"],
    });

    setInterval(() => {
      this.checkCartItems();
    }, 1000);
  }

  waitForCart(maxRetry = 100) {
    let retryCount = 0;
    const checkCart = () => {
      if (window.cart || (window.__initialData && window.__initialData.cart)) {
        this.checkCartItems();
      } else if (retryCount < maxRetry) {
        retryCount++;
        setTimeout(checkCart, 100);
      } else {
        console.error(
          "CathayLoyaltyForm: Cart not available after maximum retries."
        );
      }
    };
    checkCart();
  }

  setupEventListeners() {
    const toggle = this.querySelector(".cathay-toggle");
    const fields = this.querySelector(".cathay-form-fields");
    const inputs = this.querySelectorAll(
      ".cathay-firstname, .cathay-lastname, .cathay-number"
    );

    if (!toggle || !fields) {
      if (!toggle)
        console.error("CathayLoyaltyForm: Toggle checkbox not found");
      if (!fields)
        console.error("CathayLoyaltyForm: Form fields container not found");
      return;
    }

    toggle.addEventListener("change", (e) => {
      fields.style.display = e.target.checked ? "flex" : "none";
    });

    inputs.forEach((input) =>
      input.addEventListener("input", this.debounceUpdate.bind(this))
    );
  }

  debounceUpdate() {
    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => this.updateCathayInfo(), 300);
  }

  updateCathayInfo() {
    const firstname =
      this.querySelector(".cathay-firstname")?.value?.trim() || "";
    const lastname =
      this.querySelector(".cathay-lastname")?.value?.trim() || "";
    const number = this.querySelector(".cathay-number")?.value?.trim() || "";

    let currentNote = "";
    if (window.cart && window.cart.note) {
      currentNote = window.cart.note;
    } else if (
      window.__initialData &&
      window.__initialData.cart &&
      window.__initialData.cart.note
    ) {
      currentNote = window.__initialData.cart.note;
    }

    let cleanNote = currentNote
      .replace(
        /(cathay firstname *: *[^\n]*\n?|cathay lastname *: *[^\n]*\n?|cathay number *: *[^\n]*\n?)/gi,
        ""
      )
      .trim();

    let noteArr = [];
    if (firstname) noteArr.push(`cathay firstname: ${firstname}`);
    if (lastname) noteArr.push(`cathay lastname: ${lastname}`);
    if (number) noteArr.push(`cathay number: ${number}`);
    if (cleanNote) noteArr.push(cleanNote);

    const newNote = noteArr.join(", ");

    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        note: newNote,
        attributes: {
          cathay_firstname: firstname,
          cathay_lastname: lastname,
          cathay_number: number,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(
          new CustomEvent("cathay:updated", {
            detail: { firstname, lastname, number, note: newNote },
          })
        );
      })
      .catch((error) => {
        console.error("CathayLoyaltyForm: Error updating Cathay info:", error);
      });
  }

  checkCartItems() {
    const container = this.querySelector(".cathay-loyalty-container");
    if (!container) {
      console.error("CathayLoyaltyForm: Container not found");
      return;
    }

    let hasItems = false;

    if (window.cart && window.cart.items) {
      hasItems = window.cart.items.length > 0;
    } else if (
      window.__initialData &&
      window.__initialData.cart &&
      window.__initialData.cart.items
    ) {
      hasItems = window.__initialData.cart.items.length > 0;
    } else {
      const cartItems = document.querySelectorAll(
        '[x-for*="cart.items"], .cart-item, [data-cart-item]'
      );
      hasItems = cartItems.length > 0;
    }

    if (hasItems) {
      container.style.display = "flex";
    } else {
      container.style.display = "none";
    }
  }

  disconnectedCallback() {
    if (this.cartObserver) {
      this.cartObserver.disconnect();
    }
  }
}

// Register the web component
customElements.define("cathay-loyalty-form", CathayLoyaltyForm);
